import { useQuery } from "@apollo/client"
import { useState } from "react"
import { Flex, Text } from "rebass/styled-components"
import PleaseWait from "../../components/PleaseWait"
import { GET_LAB_RESULT_DOCUMENTS, GET_LAB_RESULT_DOCUMENTS_PAGE } from "../../graphql/queries"
import { IGetLabResultsDocumentsInput, IGetLabResultsDocumentsOutput, IGetLabResultsDocumentsPageOutput, IGetLabResultsDocumentsPageInput } from "../../graphql/types/queries/labs"

const Page = ({ patientId, labResultId, pageId }: { patientId: string, labResultId: number, pageId: string }) => {
  const [imgHeightRatio, setImgHeightRatio] = useState(1)
  const { data, loading, error } = useQuery<IGetLabResultsDocumentsPageOutput, IGetLabResultsDocumentsPageInput>(GET_LAB_RESULT_DOCUMENTS_PAGE, {
    variables: {
      patientId,
      labResultId,
      pageId
    }
  })

  if (!!loading) return <PleaseWait />
  let mimeType = data?.providerGetLabResultDocumentsPage.mimeType
  if ((mimeType || '').indexOf(';') > -1) {
    mimeType = mimeType?.split(';')[0]
  }

  if ((mimeType || '').indexOf('pdf') > -1) {
    return (
      <embed type={mimeType} style={{ width: '100%', height: '100%' }} src={`data:${mimeType};base64,${data?.providerGetLabResultDocumentsPage.attachement}`} />
    )
  }

  const img = new Image()
  img.onload = () => {
    const imgWidth = img.naturalWidth;
    const imgHeight = img.naturalHeight;
    setImgHeightRatio(imgHeight / imgWidth)
    console.log('imgWidth: ', imgWidth);
    console.log('imgHeight: ', imgHeight);
  }
  img.src = `data:${mimeType};base64,${data?.providerGetLabResultDocumentsPage.attachement}`

  return (
    <Flex width={'100%'} height='100%' style={{
      overflowY: 'scroll'
    }}>
      <Flex width={'100%'} style={{
        backgroundImage: `url(data:${mimeType};base64,${data?.providerGetLabResultDocumentsPage.attachement})`,
        backgroundSize: 'cover', height: `calc(700px * ${imgHeightRatio})`
      }}>

      </Flex>

    </Flex>
  )
}

const LabDocumentViewer = ({ patientId, labResultId }: { patientId: string, labResultId: number }) => {
  const [pageIndex, setPageIndex] = useState(0)
  const { data, loading, error } = useQuery<IGetLabResultsDocumentsOutput, IGetLabResultsDocumentsInput>(GET_LAB_RESULT_DOCUMENTS, {
    variables: {
      patientId,
      labResultId
    }
  })

  if (!!loading) return <PleaseWait />

  if (!data || data.providerGetLabResultDocuments.length < 1) {
    return <Flex width={'100%'} height='100%' justifyContent={'center'} alignItems='center'>
      <Text>No Document</Text>
    </Flex>
  }

  return (<Flex width={'100%'} height='100%' flexDirection={'column'}>
    <Flex justifyContent={'center'} alignItems='center' width={'calc(100% + 24px)'} marginLeft='-24px' padding={1} backgroundColor='#acacac'>
      <Flex style={{
        borderRadius: '16px',
        height: '24px',
        width: '24px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: pageIndex > 0 ? '#344f79' : '#bfbfc0',
        color: 'white',
        cursor: pageIndex > 0 ? 'pointer' : ''
      }}
        onClick={() => setPageIndex(Math.max(pageIndex - 1, 0))}>
        {'<'}
      </Flex>
      <Text marginX={3}>{`Document  ${pageIndex + 1} / ${data.providerGetLabResultDocuments.length}`}</Text>
      <Flex style={{
        borderRadius: '16px',
        height: '24px',
        width: '24px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: pageIndex <data.providerGetLabResultDocuments.length - 1 ? '#344f79' : '#bfbfc0',
        color: 'white',
        cursor: pageIndex <data.providerGetLabResultDocuments.length - 1 ? 'pointer' : ''
      }}
        onClick={() => setPageIndex(Math.min(pageIndex + 1, data.providerGetLabResultDocuments.length - 1))}>
        {'>'}
      </Flex>
    </Flex>
    <Page patientId={patientId} labResultId={labResultId} pageId={data.providerGetLabResultDocuments[pageIndex].pageid} />
  </Flex>
  )
}

export default LabDocumentViewer


// <Flex width={'100%'} height='100%' flexDirection={'column'}>
// <Flex justifyContent={'center'} alignItems='center' width={'100%'} padding={1} backgroundColor='red'>
//   <Flex style={{
//     borderRadius: '16px',
//     height: '24px',
//     width: '24px',
//     justifyContent: 'center',
//     alignItems: 'center'
//   }}>
//     {'<'}
//   </Flex>
// </Flex>
//   <Flex width={'100%'} flex={1}>
//     <Page patientId={patientId} labResultId={labResultId} pageId={data.providerGetLabResultDocuments[pageIndex].pageid} />
//   </Flex>
// </Flex>